
import Vue from 'vue';

export interface PartnerLogo {
	id: number;
	name: string;
	src: string;
}

const defaultPartnerLogos: PartnerLogo[] = [
	{ id: 1, name: 'Ogilvy', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%201.png' },
	{ id: 2, name: 'Bulgari', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%204.png' },
	{ id: 3, name: 'Accenture', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%206.png' },
	{ id: 4, name: 'Pascall Watson', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/PascallWatson.png' },
	{ id: 5, name: 'Swecco', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/sweco_white.png' },
	{ id: 6, name: 'Henry J Lyons', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-henry-j-lyons.svg' },
	{ id: 7, name: 'Grosmann', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-groosman.svg' },
	{ id: 8, name: 'Nike', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%202.png' },
	{ id: 9, name: 'Woods Bagot', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-woods-bagot.png' },
	{ id: 10, name: 'Honda', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%205.png' },
	{ id: 11, name: 'Sheppard Robson', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-sheppard-robson.svg' },
	{ id: 12, name: 'Adidas', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/home/newHome%209-25/logos/image%203.png' },
	{ id: 13, name: 'Benoy', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-benoy.svg' },
	{ id: 14, name: 'Cube 3', src: 'https://cdn.rundiffusion.com/file/rd-web-assets/rd-web/industries/architecture/showcase/logo-cube3.svg' },
];

export default Vue.extend({
	name: 'LogoMarquee',
	props: {
		backgroundColorHex: {
			type: String,
			default: '#171717',
		},
		logos: {
			type: Array,
			default: () => defaultPartnerLogos,
		},
		tagline: {
			type: String,
			default: "Trusted by the world's leading architecture firms",
		},
		durationSeconds: {
			type: Number,
			default: 40,
		},
		gradientWidthPx: {
			type: Number,
			default: 64,
		},
	},
	computed: {
		duplicatedLogos (): PartnerLogo[] {
			const logos = (this.logos as PartnerLogo[]) || [];
			return [...logos, ...logos];
		},
	},
});
